import { render, staticRenderFns } from "./CreateStock.vue?vue&type=template&id=4d988544"
import script from "./CreateStock.vue?vue&type=script&lang=js"
export * from "./CreateStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports